<template>
    <ValidationObserver class="col" tag="div" ref="form" v-slot="{ invalid, handleSubmit }">
        <Loading />
        <Message />

        <CForm method="post" @submit.prevent="handleSubmit(submit)">
            <CRow>
                <CCol col="12" v-if="agreement.file && !uploadAgain" class="my-2">
                    <span class="text-mute mfe-3">فایل قرارداد آپلود شده</span>
                    <a class="btn btn-secondary" @click="uploadAgain = true">تغییر</a>
                </CCol>
                <CCustomImageInputFile
                    v-else
                    col="12" sm="6"
                    vid="file"
                    hideLabel
                    :name="$t('agreement.file')"
                    v-model="agreement.file"
                    path="agreements"
                    class="mt-3"
                    rules="mimes:pdf"
                >
                    <template #after-box>
                        <span class="text-center font-xs d-block text-muted">
                            فایل قرارداد باید به صورت PDF بازگذاری شود.
                            <CLink v-if="agreement.file" class="text-danger" @click="uploadAgain = false">انصراف</CLink>
                        </span>
                    </template>
                </CCustomImageInputFile>
                <CCustomSelect
                    sm="12"
                    v-model="agreement.type"
                    :options="AgreementTypeOptionWithNull"
                    vid="type"
                    required
                    rules="required"
                    :name="$t('agreement.type')"
                />
                <CCustomSelect
                    sm="12"
                    v-model="agreement.status"
                    :options="AgreementStatusOptionWithNull"
                    vid="status"
                    required
                    rules="required"
                    :name="$t('agreement.status')"
                />
                <CCol col="12">
                    <div role="group" class="form-group datepicker">
                        {{ $t('agreement.started_at') }}
                        <datePicker
                            vid="started_at"
                            clearable
                            format="YYYY-MM-DD"
                            display-format="dddd jDD jMMMM jYYYY"
                            input-class="form-control"
                            v-model="agreement.started_at"
                            type="date"
                        />
                    </div>
                </CCol>
                <CCol col="12">
                    <div role="group" class="form-group datepicker">
                        {{ $t('agreement.finished_at') }}
                        <datePicker
                            vid="finished_at"
                            clearable
                            format="YYYY-MM-DD"
                            display-format="dddd jDD jMMMM jYYYY"
                            input-class="form-control"
                            v-model="agreement.finished_at"
                            type="date"
                        />
                    </div>
                </CCol>

                <CCustomInputCheckbox
                    col="12"
                    class="mb-3"
                    vid="is_locked"
                    :name="$t('agreement.is_locked')"
                    v-model="agreement.is_locked"
                    ref="customCheckbox"
                />

                <CCustomSearchableInput
                    v-if="$policy('agreement').create_any_or_group && !agreement.id"
                    col="12"
                    vid="user_id"
                    :name="$t('attributes.created_for')"
                    v-model="userId"
                    required
                    rules="required"
                    :items="selectableUsers"
                />

                <CCol sm="12">
                    <CButton :disabled="invalid" type="submit"  color="primary" class="mt-3 px-4 float-right">{{ $t('submit') }}</CButton>
                </CCol>
            </CRow>

        </CForm>
    </ValidationObserver>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { AgreementType, AgreementStatus } from '@/constants'
import { AgreementTypeOptionWithNull, AgreementStatusOptionWithNull } from '@/common/data'

export default {
    name: 'Form',

    props: {
        submit: {
            default() {},
            required: true,
        },
        agreement: {
            default() {
                return {
                    file: '',
                    type: '',
                    user_id: null,
                    status: AgreementStatus.PENDING,
                    is_locked: 0,
                    started_at: '',
                    finished_at: ''
                }
            },
        },
    },

    data() {
        return {
            AgreementStatus,
            AgreementType,
            AgreementTypeOptionWithNull,
            AgreementStatusOptionWithNull,
            userId: '',
            uploadAgain: false,
        }
    },

    computed: {
        ...mapGetters({
            selectableUsers: 'user/selectableUsers',
        })
    },

    watch: {
        userId(val) {
            if (val) {
                this.agreement.user_id = val.value || null
            } else {
                this.agreement.user_id = null
            }
        }
    },

    methods: {
        ...mapActions({
            editAgreement: 'agreement/edit'
        }),
        // used in reset form in parent component
        destory() {
            this.userId = null
            this.$refs.customCheckbox.checked = null
        },
    }
}
</script>